import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


function animateFrom(elem, direction) {

    direction = direction || 1;

    let x = 0;
    let y = direction * 100;

    const fromLeft = elem.closest('.section-media-content')?.classList.contains('section-media-content--desktop-media-first') // from left
    const fromRight = elem.closest('.section-media-content')?.classList.contains('section-media-content--desktop-text-first') // from right

    elem.style.transform = "translate(" + x + "px, " + y + "px)";
    elem.style.opacity = "0";



    if (elem.classList.contains('media')) {

        if (fromLeft) {
            x = -100;
            y = 0;
        } else if (fromRight) {
            x = 100;
            y = 0;
        }
    }

    gsap.fromTo(elem, { x: x, y: y, opacity: 0 }, {
      duration: 1.25,
      x: 0,
      y: 0,
      opacity: 1,
      ease: "expo",
      overwrite: 'auto'
    });

  }

  function hide(elem) {
    gsap.set(elem, { opacity: 0 });
  }


export const init = () => {


    const textElements = gsap.utils.toArray(`

        .section-text__headline > *,
        .section-text__text > *,
        .section-text .sqace-button,
        .section-text .button-group,

        .section-contact__text > *,
        .contact-form > *,

        .section-contact-item .contact-item,
        .section-contact-item > .text > *,

        .section-cards__section-heading > *,
        .section-cta__text > *,
        .section-cta__button-group,

        .section-accordion__text > *,

        .section-split-text__text > *,

        .section-media-content--desktop-media-first .section-media-content__media,
        .section-media-content--desktop-text-first .section-media-content__media,
        .section-media-content__text > *,
        .section-media-content__content > *,
        .section-media-content__button-group


    `);


    textElements.forEach(elem => {

        hide(elem); // assure that the element is hidden when scrolled into view

        elem.style.opacity = 0;
        elem.style.willChange =  'transform, opacity';

        ScrollTrigger.create({
          trigger: elem,
          invalidateOnRefresh: true,
        //   markers: true,
          start: 'top bottom',
          once: true, // nur beim ersten Erscheinen einblenden, danach stehen lassen (kein Ausblenden/Neu-Einfliegen beim Zurückscrollen)
          onEnter: function() { animateFrom(elem) },
        });
      });

}

export default init;
